import { useEffect, useRef, useState } from 'react';

// The recording row replaces its trigger, then returns focus when it closes: to the
// trigger, or, once a take is finished, to the field in `finishedRef` when given
// (where its transcript lands).
export default function useInlineCapture(capture, { finishedRef } = {}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const restoreFocus = useRef(null);
  useEffect(() => {
    if (open && capture.status === 'ready') {
      restoreFocus.current = 'finished';
      setOpen(false);
    }
  }, [open, capture.status]);
  useEffect(() => {
    if (open || !restoreFocus.current) return;
    const field = restoreFocus.current === 'finished' ? finishedRef?.current?.querySelector('textarea:not(:disabled), input:not(:disabled)') : null;
    restoreFocus.current = null;
    (field || triggerRef.current)?.focus({ preventScroll: true });
  }, [open, finishedRef]);
  const start = () => { setOpen(true); capture.start(); };
  const cancel = () => {
    capture.cancel();
    restoreFocus.current = 'trigger';
    setOpen(false);
  };
  return { open, start, cancel, triggerRef };
}
